// extracted by mini-css-extract-plugin
export default {"form":"EditarCliente_form__sqH1s","areaBtn":"EditarCliente_areaBtn__PQnl0","btn":"EditarCliente_btn__JN3zG"};